import Logo from './assets/images/logo.png';
import './App.css';
import Form from './Form';

function App() {
  return (
    <div className='row w-100'>
      <div className='col-12 col-lg-12 mx-auto ms-2 p-2'>
        <div className='card mb-4'>
          <div className='card-header text-center'>
            <img src={Logo} style={{ width: '250px' }} />
          </div>
          <div className='card-body'>
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
